import { openModal } from './modalsActions';
import { modals, bookingErrorType } from '../utils/constants';
import ApiClient from '../utils/apiClient';
import { setPendingBookingCourtEventId } from './pendingBookingActions';

export function bookCourt(
  courtEventId,
  startTime,
  eventDate,
  eventLocation,
  eventClubName,
  refreshAction,
  courtSizeType,
  courtType,
  friendsEmails = null
) {
  return dispatch => {
    ApiClient.post(`/api/v1/book-court/${courtEventId}/`, {
      invited_users_emails: friendsEmails,
      court_size_type: courtSizeType
    })
      .then(() => {
        dispatch(setPendingBookingCourtEventId(null));
        dispatch(refreshAction);
        dispatch(
          openModal(modals.BOOKING_COURT_COMPLETE, {
            startTime,
            eventDate,
            eventLocation,
            eventClubName,
            courtType
          })
        );
      })
      .catch(error => {
        const data = error && error.response && error.response.data;
        if (data.error_type === bookingErrorType) {
          dispatch(openModal(modals.BOOKING_SESSION_FAILURE, data));
        }
      });
  };
}

export function startCourtBooking(
  courtEventId,
  startTime,
  eventDate,
  eventLocation,
  eventClubName,
  refreshAction,
  courtSizeType,
  courtType,
  inviteFriendsCount
) {
  return dispatch =>
    dispatch(
      openModal(modals.INVITE_FRIENDS_TO_COURT_BOOKING, {
        courtEventId,
        startTime,
        eventDate,
        eventLocation,
        eventClubName,
        refreshAction,
        courtSizeType,
        courtType,
        inviteFriendsCount
      })
    );
}



// WEBPACK FOOTER //
// ./src/actions/courtsBookingActions.js